import React, { Component } from "react";
import PDFViewer from "components/PDFViewer/PDFViewer";
import PDFJSBackend from "backends/pdfjs";
import queryString from "query-string";

class PDFviewer extends Component {
  render() {
    let url = this.props.location.search;
    let params = queryString.parse(url);
    console.log(params);
    return (
      <div style={{ height: "1000px" }}>
        <PDFViewer backend={PDFJSBackend} src={params.file} />
      </div>
    );
  }
}

export default PDFviewer;
